// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__11QqV","tab":"Tabs_tab__2O1_y","tabActive":"Tabs_tabActive__2b7ZQ"};